import { Modal } from 'antd';
import type { ReactNode } from 'react';
import styles from './index.module.scss';

export interface ActionConfirmModalOptions {
  title: ReactNode;
  content: ReactNode;
  onOk?: () => void | Promise<unknown>;
  onCancel?: () => void;
  okText?: string;
  cancelText?: string;
  showCancel?: boolean;
}

/** 操作确认弹窗：统一外观，异步 onOk 沿用 Modal 的加载与防重复提交行为。 */
const ActionConfirmModal = ({ title, content, onOk, onCancel, okText = '确定', cancelText = '取消', showCancel = true }: ActionConfirmModalOptions) =>
  Modal.confirm({
    title,
    content,
    onOk,
    onCancel,
    okText,
    cancelText,
    okCancel: showCancel,
    icon: null,
    width: 400,
    centered: true,
    closable: true,
    maskClosable: false,
    autoFocusButton: null,
    className: styles.modal
  });

export default ActionConfirmModal;
